import axios from 'axios';


// axios.defaults.baseURL = 'http://localhost:3010/api/v1';
// axios.defaults.baseURL = 'http://197.210.166.58:4006/api/v1';
// axios.defaults.baseURL = 'http://10.0.5.52:3011/api/v1';
axios.defaults.baseURL = 'https://vitelwireless.net:3010/api/v1';
export default axios;
